export default {
	methods: {
		forceFileDownload(stream, name='schedule', ext='pdf'){
			const url = window.URL.createObjectURL(new Blob([stream],{type: "application/octet-stream"}));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', `${name}.${ext}`); //or any other extension
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		},
	},
}
